import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function TresLechesPage() {

    const heroData = [
        {
          title: "Tres Leches",
          content: "Tres leches is a soft and moist sponge cake soaked in a mixture of three kinds of milk: evaporated milk, condensed milk, and heavy cream. Popular in Latin American cuisine, it's topped with whipped cream and often garnished with fruits or cinnamon.",
          image: images.TresLechesHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Tres Leches Classic",
        content: "Sponge cake soaked in three kinds of milk",
        price: 0,
        image: [
          images.TresLeches1,
        ]
      },
      {
        name: "Tres Leches Saffron",
        content: "Traditional Tres leches infused with saffron",
        price: 0,
        image: [
          images.TresLeches2,
        ]
      },
      {
        name: "Tres Leches Pistachio",
        content: "Moist cake with a pistachio twist",
        price: 0,
        image: [
          images.TresLeches3,
        ]
      },
      {
        name: "Classic Tiramisu",
        content: "Layers of espresso-soaked ladyfingers, creamy mascarpone",
        price: 0,
        image: [
          images.TresLeches4,
        ]
      },
      {
        name: "Matcha Tiramisu",
        content: "Layers of matcha-soaked sponge, creamy mascarpone",
        price: 0,
        image: [
          images.TresLeches5,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Tres Leches Saffron",
        image1: [
          images.TresLeches2,
        ],
        content1: "Traditional Tres leches infused with saffron",
        name2: "Tres Leches Pistachio",
        image2: [
          images.TresLeches3,
        ],
        content2: "Moist cake with a pistachio twist"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
